export default {"src":"/login-app/[GIT_HASH]/_next/static/media/auto_observe.100f002c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};